<div class="nav-header" [ngClass]="{'nav-header-nondefault-environment': nonDefaultEnvironmentSelected}">
    <img *ngIf="nonDefaultEnvironmentSelected" src="https://media.winstonfinancial.com/Stingray/Images/hrallynavbar-transparent.png" class="nav-header-client-logo" />
    <img *ngIf="!nonDefaultEnvironmentSelected" src="https://media.winstonfinancial.com/Stingray/Images/hrallynavbar-transparent-dark.png" class="nav-header-client-logo" />
    <div class="nav-header-links-container">
        <app-nav-user-menu class="nav-header-user-menu"></app-nav-user-menu>
        <a mat-button href="https://www.help.winstonbenefits.com/" target="_blank" class="nav-header-help-link">
            <i class="nav-header-help-link-icon fas fa-question"></i>
            <span class="nav-header-help-link-desc">HELP</span>
        </a>
    </div>
</div>